import usePopup from '@/shared/hooks/usePopup'
import { CSSProperties, ReactNode, useRef, useState } from 'react'
import css from './antDateRangeChipsPicker.module.css'
import FadeInPanel from '@/shared/Animated/FadeInPanel'
import Close from '../../../../assets/icons/close.svg?react'
import ArrowDown from '../../../../assets/icons/arrowDown.svg?react'
import cn from '@/utils/cn'
import Button from '@/shared/Buttons/Button'
import timeUtils from '@/utils/time.utils'
import './antDateRangeChipsPicker.css'
import AntDateRangePicker, { IDisabledTimes } from '../../DatePickers/AntDateRangePicker'

interface IProps {
  startTs: number
  endTs: number

  onChange: (startTs: number, endTs: number) => void
  onOpen?: () => void

  disabledRangeTime?: (date: number, range: 'start' | 'end', from: number) => Partial<IDisabledTimes>
  disabledDate?: (date: number, type: string, range: 'start' | 'end', from: number) => boolean
  withTime?: boolean
  disabled?: boolean
  allowSelectInFuture?: boolean
  title?: string
  style?: CSSProperties
  type?: 'default' | 'inline'
  isTipHidden?: boolean
  isCloseHidden?: boolean
}

const AntDateRangeChipsPicker = ({ type = 'default', ...props }: IProps) => {
  const ref = useRef<HTMLInputElement>()
  const { open, setOpen } = usePopup(ref)
  const [startTs, setStartTs] = useState(props.startTs)
  const [endTs, setEndTs] = useState(props.endTs)
  const stepRef = useRef<'start' | 'end'>(null)
  const pickerRef = useRef<any>(null)

  const renderInput = () => {
    const isSavedDataFilled = Boolean(props.startTs) && Boolean(props.endTs)
    let tip = ''
    if (!props.isTipHidden)
      tip = !isSavedDataFilled
        ? 'Все'
        : `${timeUtils.formatDate(props.startTs, 'dd.MM.yyyy')} - ${timeUtils.formatDate(props.endTs, 'dd.MM.yyyy')}`
    return (
      <div data-filled={isSavedDataFilled} className={cn('text-nm line-clamp', css.inputText)}>
        {props.title}
        {!props.isTipHidden && <span className={cn(css.inputTextTip, 'text-heading-6')}>{tip}</span>}
      </div>
    )
  }

  const renderFooter = () => {
    if (props.withTime) return null
    return (
      <div
        className="flex-space-between"
        onClick={(ev) => {
          ev.stopPropagation()
        }}
      >
        <Button
          size="default"
          type="tetriary"
          text="Сбросить"
          disabled={!Boolean(startTs) && !Boolean(endTs)}
          onClick={handleClearData}
        />
        <Button
          size="default"
          type="primary"
          text="Применить"
          onClick={() => {
            props.onChange(startTs, endTs), setOpen(false)
          }}
        />
      </div>
    )
  }

  const handleClearData = () => {
    props.onChange(null, null)
    setEndTs(null)
    setStartTs(null)
  }

  const renderClose = () => {
    if (!(Boolean(props.startTs) && Boolean(props.endTs)) || props.isCloseHidden) return null
    return (
      <div
        className={css.closeIcon}
        onClick={(e) => {
          e.stopPropagation()
          handleClearData()
        }}
      >
        <Close width={8.5} height={8.5} />
      </div>
    )
  }

  const handleChange = (start, end) => {
    setStartTs(start)
    setEndTs(end)
    if (start && end && props.withTime && stepRef.current === 'end') {
      props.onChange(start, end)
      setOpen(false)
    }
  }

  const handleWrapperClick = () => {
    if (props.disabled) return
    if (props.onOpen && !open) props.onOpen()
    setOpen((prev) => !prev)
  }

  const renderPanel = (panel: ReactNode) => {
    if (!props.withTime) return panel
    return (
      <div>
        {panel}
        <div className={css.footer}>
          <Button
            size="small"
            type="tetriary"
            text="Сбросить"
            onClick={handleClearData}
            disabled={!startTs && !endTs}
          />
        </div>
      </div>
    )
  }

  return (
    <div
      className={css.wrapper}
      data-open={open}
      ref={ref}
      data-filled={Boolean(props.startTs) && Boolean(props.endTs)}
      data-type={type}
      data-with-time={props.withTime}
      style={props.style}
      onClick={handleWrapperClick}
    >
      {renderInput()}
      {!props.disabled && (
        <ArrowDown data-open={open} data-filled={Boolean(startTs) && Boolean(endTs)} className={css.arrow} />
      )}
      {renderClose()}
      <FadeInPanel open={open} className={css.options} style={{ backgroundColor: '#fff' }}>
        <div style={{ padding: '8px 12px' }} onClick={(e) => e.stopPropagation()}>
          <AntDateRangePicker
            {...props}
            ref={pickerRef}
            disabledDate={
              props.disabledDate
                ? (date: number, type: string, from: number) => props.disabledDate(date, type, stepRef.current, from)
                : undefined
            }
            startTs={startTs}
            endTs={endTs}
            open={true}
            panelStyle={{ width: '100%' }}
            className={'dataPicker'}
            getPopupContainer={(triggerNode) => triggerNode.parentElement}
            placement="bottomRight"
            onChange={handleChange}
            renderExtraFooter={renderFooter()}
            handleEditingRangeChange={(value) => (stepRef.current = value)}
            panelRender={renderPanel}
          />
        </div>
      </FadeInPanel>
    </div>
  )
}

export default AntDateRangeChipsPicker
